import { AvvirEvent } from "type_aliases";

export type ProcoreRfiManagersLoadedEvent = AvvirEvent<typeof PROCORE_RFI_MANAGERS_LOADED, any>;

const procoreRfiManagersLoaded = (procoreRfiManagers): ProcoreRfiManagersLoadedEvent => ({
  type: PROCORE_RFI_MANAGERS_LOADED,
  payload: procoreRfiManagers
});

export const PROCORE_RFI_MANAGERS_LOADED = "procore_rfi_managers_loaded";

export default procoreRfiManagersLoaded;